// Set a hash for each modal to make it searchable to see which modal the
// window.location.hash is pointing to.
export default {
    preferences: {
        show: false,
        hash: 'preferences'
    },
    notifications: {
        show: false,
        hash: 'notifications'
    },
    newChannel: {
        show: false,
        hash: 'newChannel'
    },
    feedback: {
        show: false,
        hash: 'feedback'
    },
    newSubmission: {
        show: false,
        hash: 'newSubmission'
    },
    addLocation:{
        show: true,
        hash: 'newLocation'
    },
    keyboardShortcutsGuide: {
        show: false,
        hash: 'keyboardShortcutsGuide'
    },
    markdownGuide: {
        show: false,
        hash: 'markdownGuide'
    },
    authintication: {
        show: false,
        hash: 'authintication'
    },
    reportSubmission: {
        show: false,
        hash: 'reportSubmission',
        submission: []
    },
    reportComment: {
        show: false,
        hash: 'reportComment',
        comment: []
    },
    feedSettings: {
        show: false,
        hash: 'feedSettings'
    },
    sidebarSettings: {
        show: false,
        hash: 'sidebarSettings'
    },
    photoViewer: {
        show: false,
        hash: 'photoViewer',
        image: [],
        submission: []
    },
    gifPlayer: {
        show: false,
        hash: 'gifPlayer',
        gif: [],
        submission: []
    },
    embedViewer: {
        show: false,
        hash: 'embedViewer',
        submission: []
    },
    messages: {
        show: false,
        hash: 'messages'
    },
    search: {
        show: false,
        hash: 'search'
    },
    mobileVisitorWarning: {
        show: false,
        hash: 'mobileVisitorWarning'
    },
    banUser: {
        show: false,
        hash: 'banUser',
        user: [], 
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modals.js